import React from "react";
import FasterDeliveries from "../../assets/FasterDeliveries.png";
import Operation from "../../assets/Operation.png";
import CostEfficiency from "../../assets/CostEfficiency.png";

const ChoosePackky = () => {
  const features = [
    {
      img: FasterDeliveries,
      title: "Faster Deliveries",
      text: "Smart routing and quick dispatch ensure your parcels reach on time, every time. Speed matters — and we make sure you deliver fast.",
    },
    {
      img: Operation,
      title: "Seamless Operations",
      text: "From booking to delivery, everything runs in sync. Whether you’re sending to stores, customers, or vendors, Packky (powered by Chaafo) keeps it all connected.",
    },
    {
      img: CostEfficiency,
      title: "Cost Efficiency",
      text: "No more fuel waste or idle time. Our platform helps reduce operational costs by matching deliveries to optimized routes and right-sized vehicles.",
    },
  ];

  return (
    <section
      className="w-full bg-[#ececec] px-4 py-12 md:px-6 md:py-16 lg:px-8"
      
    >
      <div className="mx-auto w-full max-w-[1280px] rounded-[22px] bg-white px-6 py-10 shadow-[0_12px_35px_rgba(0,0,0,0.08)] md:px-10 md:py-12 lg:px-12">
        <div className="mx-auto max-w-[760px] text-center">
        <div className="mt-4 text-center">
  <h2 className="font-bold text-[#212529] text-[24px] sm:text-[26px] md:text-[28px] lg:text-[28px] leading-tight tracking-tight font-sf">
    Why Choose Packky?
  </h2>

  <h5 className="mt-2 font-medium text-[#667085] text-[16px] sm:text-[18px] md:text-[18px] lg:text-[20px] font-sf">
    Logistics built for speed, simplicity, and savings.
  </h5>
</div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-1 lg:grid-cols-3">
          {features.map((item, index) => (
            <div key={index} className="flex">
              <div className="flex min-h-[280px] font-sf w-full flex-col items-center rounded-[18px] bg-[#e0e0e0] px-7 py-8 text-center shadow-[0_2px_10px_rgba(0,0,0,0.04)]">
                <img
                  src={item.img}
                  alt={item.title}
                  width="60"
                  height="60"
                  className="mb-5 rounded-full border border-blue-500 bg-white p-1"
                />

                <h5 className="text-[20px] font-bold leading-snug text-[#212529]">
                  {item.title}
                </h5>

                <p className="mt-4 text-[16px] leading-6 text-[#667085]">
                  {item.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ChoosePackky;